const summaryLastUpdatedAtFormat = (lastUpdatedAtTimestamp: string) => {
  const lastUpdatedAt = new Date(lastUpdatedAtTimestamp.slice(0, 19));

  return `${lastUpdatedAt.toDateString()}, ${lastUpdatedAt.toTimeString().slice(0, 8)}`;
};

export default summaryLastUpdatedAtFormat;
